import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../shared/redux/store';
import { fetchSettings } from './settingsSlice';
import { useTranslation } from 'react-i18next';

const Settings: React.FC = () => {
  const dispatch = useAppDispatch();

  const { i18n } = useTranslation();

  const { loaded, language } = useAppSelector(state => state.settings);

  useEffect(() => {
    if (!loaded) {
      dispatch(fetchSettings()).catch((err) => console.log(err));
    }
  }, []);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  return (
    <></>
  );
};

export default Settings;
